// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
export type WebsiteInitializationErrorData = "invalidContract" | "invalidNativeMessagingHost" | string;